import { useEffect, useState } from 'react';

const EMPTY = {
  idPersona: 0,
  tipoDireccion: '',
  calle: '',
  numeroExterior: '',
  numeroInterior: '',
  colonia: '',
  municipio: '',
  estado: '',
  codigoPostal: '',
  pais: '',
  esPrincipal: false,
};

export default function Modal({
  open,
  mode = 'new',
  data = null,
  fkValue = 0,
  onClose,
  onSubmit,
  inline = false,
}) {
  EMPTY.idPersona = fkValue;
  const [form, setForm] = useState(EMPTY);
  const [errors, setErrors] = useState({
    tipoDireccion: '',
    calle: '',
    numeroExterior: '',
    numeroInterior: '',
    colonia: '',
    municipio: '',
    estado: '',
    codigoPostal: '',
    pais: '',
  });

  const validateField = (field, rawValue) => {
    const value = (rawValue ?? '').toString().trim();
    let error = '';

    switch (field) {
      case 'tipoDireccion':
        if (!value) error = 'El tipo de dirección es obligatorio.';
        break;
      case 'calle':
        if (!value) error = 'La calle es obligatoria.';
        break;
      case 'numeroExterior':
        if (!value) error = 'El número exterior es obligatorio.';
        break;
      case 'numeroInterior':
        // Opcional, se envía 0 si vacío
        break;
      case 'colonia':
        if (!value) error = 'La colonia es obligatoria.';
        break;
      case 'municipio':
        if (!value) error = 'El municipio es obligatorio.';
        break;
      case 'estado':
        if (!value) error = 'El estado es obligatorio.';
        break;
      case 'codigoPostal':
        if (!value) error = 'El código postal es obligatorio.';
        break;
      case 'pais':
        if (!value) error = 'El país es obligatorio.';
        break;
      default:
        break;
    }

    setErrors((prev) => ({ ...prev, [field]: error }));
    return !error;
  };

  const validateAll = () => {
    const fields = [
      'tipoDireccion',
      'calle',
      'numeroExterior',

      'colonia',
      'municipio',
      'estado',
      'codigoPostal',
      'pais',
    ];
    return fields.every((f) => validateField(f, form[f]));
  };

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
    validateField(field, value);
  };

  useEffect(() => {
    if (mode === 'edit' && data) {
      const filled = {
        idDireccion: data.idDireccion ?? 0,
        idPersona: fkValue,
        tipoDireccion: data.tipoDireccion ?? '',
        calle: data.calle ?? '',
        numeroExterior: data.numeroExterior ?? '',
        numeroInterior: (data.numeroInterior === '0' || data.numeroInterior === 0) ? '' : (data.numeroInterior ?? ''),
        colonia: data.colonia ?? '',
        municipio: data.municipio ?? '',
        estado: data.estado ?? '',
        codigoPostal: data.codigoPostal ?? '',
        pais: data.pais ?? '',
        esPrincipal: !!data.esPrincipal,
      };
      setForm(filled);

      // Validar todo lo precargado
      Object.keys(errors).forEach((key) => {
        validateField(key, filled[key]);
      });
    } else {
      setForm(EMPTY);
      setErrors({
        tipoDireccion: '',
        calle: '',
        numeroExterior: '',
        numeroInterior: '',
        colonia: '',
        municipio: '',
        estado: '',
        codigoPostal: '',
        pais: '',
      });
    }
  }, [mode, data]);

  if (!open) return null;

  const allRequiredFilled =
    form.idPersona &&
    form.tipoDireccion.trim() &&
    form.calle.trim() &&
    form.numeroExterior.trim() &&

    form.colonia.trim() &&
    form.municipio.trim() &&
    form.estado.trim() &&
    form.codigoPostal.trim() &&
    form.pais.trim();

  const hasErrors = Object.values(errors).some((e) => !!e);
  const isSaveDisabled = !allRequiredFilled || hasErrors;

  const errorStyle = {
    color: '#b91c1c',
    fontSize: '.8rem',
    display: 'block',
    marginTop: '4px',
  };

  const Header = (
    <div
      className="roles-topbar"
      style={{
        marginBottom: '0.6rem',
        paddingRight: 16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flex: '0 0 auto',
      }}>
      <h3 className="roles-title" style={{ marginRight: 0 }}>
        {mode === 'new' ? 'Nueva dirección' : 'Editar dirección'}
      </h3>
      <button className="roles-btn" onClick={onClose} aria-label="Cerrar">✕</button>
    </div>
  );

  const Body = (
    <div
      style={{
        paddingLeft: '12%',
        paddingRight: 16,
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '0.8rem',
        overflowY: 'auto',
        flex: '1 1 auto',
        minHeight: 0,
      }}>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Tipo de dirección:</label>
        <br /><br />
        <select
          className={`infoField${errors.tipoDireccion ? ' infoField--error' : ''}`}
          value={form.tipoDireccion}
          onChange={(e) => handleChange('tipoDireccion', e.target.value)}
        >
          <option value="">Seleccione…</option>
          <option value="Casa">Casa</option>
          <option value="Trabajo">Trabajo</option>
          <option value="Otro">Otro</option>
        </select>
        {errors.tipoDireccion && <small style={errorStyle}>{errors.tipoDireccion}</small>}
      </div>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Calle:</label>
        <br /><br />
        <input
          className={`infoField${errors.calle ? ' infoField--error' : ''}`}
          value={form.calle}
          onChange={(e) => handleChange('calle', e.target.value)}
          maxLength={150}
        />
        {errors.calle && <small style={errorStyle}>{errors.calle}</small>}
      </div>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Número exterior:</label>
        <br /><br />
        <input
          className={`infoField${errors.numeroExterior ? ' infoField--error' : ''}`}
          value={form.numeroExterior}
          onChange={(e) => handleChange('numeroExterior', e.target.value)}
          maxLength={20}
        />
        {errors.numeroExterior && <small style={errorStyle}>{errors.numeroExterior}</small>}
      </div>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Número interior:</label>
        <br /><br />
        <input
          className={`infoField${errors.numeroInterior ? ' infoField--error' : ''}`}
          value={form.numeroInterior}
          onChange={(e) => handleChange('numeroInterior', e.target.value)}
          maxLength={20}
        />
        {errors.numeroInterior && <small style={errorStyle}>{errors.numeroInterior}</small>}
      </div>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Colonia:</label>
        <br /><br />
        <input
          className={`infoField${errors.colonia ? ' infoField--error' : ''}`}
          value={form.colonia}
          onChange={(e) => handleChange('colonia', e.target.value)}
          maxLength={150}
        />
        {errors.colonia && <small style={errorStyle}>{errors.colonia}</small>}
      </div>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Municipio:</label>
        <br /><br />
        <input
          className={`infoField${errors.municipio ? ' infoField--error' : ''}`}
          value={form.municipio}
          onChange={(e) => handleChange('municipio', e.target.value)}
          maxLength={150}
        />
        {errors.municipio && <small style={errorStyle}>{errors.municipio}</small>}
      </div>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Estado:</label>
        <br /><br />
        <input
          className={`infoField${errors.estado ? ' infoField--error' : ''}`}
          value={form.estado}
          onChange={(e) => handleChange('estado', e.target.value)}
          maxLength={150}
        />
        {errors.estado && <small style={errorStyle}>{errors.estado}</small>}
      </div>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Código postal:</label>
        <br /><br />
        <input
          className={`infoField${errors.codigoPostal ? ' infoField--error' : ''}`}
          value={form.codigoPostal}
          onChange={(e) => handleChange('codigoPostal', e.target.value)}
          maxLength={10}
        />
        {errors.codigoPostal && <small style={errorStyle}>{errors.codigoPostal}</small>}
      </div>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>País:</label>
        <br /><br />
        <input
          className={`infoField${errors.pais ? ' infoField--error' : ''}`}
          value={form.pais}
          onChange={(e) => handleChange('pais', e.target.value)}
          maxLength={120}
        />
        {errors.pais && <small style={errorStyle}>{errors.pais}</small>}
      </div>

      <div style={{ gridColumn: '2 / 3' }}>
        <label className="roles-title" style={{ fontSize: '.95rem', display: 'block', marginBottom: '8px' }}>Principal:</label>
        <div
          onClick={() => setForm({ ...form, esPrincipal: !form.esPrincipal })}
          style={{
            width: '38px',
            height: '20px',
            backgroundColor: form.esPrincipal ? '#10b981' : '#cbd5e1',
            borderRadius: '12px',
            position: 'relative',
            cursor: 'pointer',
            transition: 'background-color 0.2s',
            flexShrink: 0,
            margin: '0'
          }}
          title={form.esPrincipal ? "Desactivar principal" : "Marcar como principal"}
        >
          <div style={{
            width: '14px',
            height: '14px',
            backgroundColor: 'white',
            borderRadius: '50%',
            position: 'absolute',
            top: '3px',
            left: form.esPrincipal ? '21px' : '3px',
            transition: 'left 0.2s',
            boxShadow: '0 1px 2px rgba(0,0,0,0.1)'
          }} />
        </div>
      </div>
    </div>
  );

  const Footer = (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '.6rem',
        marginTop: '.8rem',
        paddingRight: 16,
        flex: '0 0 auto',
      }}
    >
      <button className="roles-btn" onClick={onClose}>Cancelar</button>
      <button
        className="btn-action"
        onClick={() => {
          if (!validateAll()) return;
          const finalForm = { ...form, numeroInterior: form.numeroInterior || '0' };
          onSubmit(finalForm, mode);
        }}
        disabled={isSaveDisabled}
        style={{
          opacity: isSaveDisabled ? 0.5 : 1,
          cursor: isSaveDisabled ? 'not-allowed' : 'pointer',
        }}
      >
        {mode === 'new' ? 'Guardar' : 'Actualizar'}
      </button>
    </div>
  );

  if (inline) {
    return (
      <div className="roles-inline-card" style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
        {Header}
        {Body}
        {Footer}
      </div>
    );
  }

  return (
    <div
      className="roles-confirm-overlay"
      role="dialog"
      aria-modal="true"
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(15,23,42,.45)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
        zIndex: 1000,
      }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose?.(); }}
    >
      <div
        className="roles-confirm-card"
        style={{
          width: 'min(900px, 96vw)',
          maxHeight: '85vh',
          background: '#fff',
          borderRadius: 12,
          boxShadow: '0 10px 30px rgba(0,0,0,.25)',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        {Header}
        {Body}
        {Footer}
      </div>
    </div>
  );
}
